'use client';
import { jsx } from 'react/jsx-runtime';
import cl from 'clsx/lite';
import { forwardRef } from 'react';

/**
 * Divider component, used to separate content. Uses `hr` element.
 *
 * @example
 * <Divider />
 */
const Divider = forwardRef(function Divider({ className, ...rest }, ref) {
    return (
    // biome-ignore lint/a11y/noAriaHiddenOnFocusable: <hr> is not foucsable but biome thinks it is
    jsx("hr", { "aria-hidden": 'true', className: cl('ds-divider', className), ref: ref, ...rest }));
});

export { Divider };
